import { InjectionToken } from '@angular/core';
export var ConfigService = new InjectionToken('BaseAppConfig');
var BaseConfigService = /** @class */ (function () {
    function BaseConfigService(config) {
        this.config = config;
        this._client = config;
    }
    Object.defineProperty(BaseConfigService.prototype, "client", {
        get: function () {
            return this._client;
        },
        enumerable: true,
        configurable: true
    });
    return BaseConfigService;
}());
export { BaseConfigService };
